import React, { useEffect, useState } from "react";
import Dialog from "./Dialog";
import activeTabBar from "../../assets/images/pk-events/btn 3.png";
import tabBar from "../../assets/images/pk-events/inactove 1.png";
import RewardButton from "../../assets/images/pk-events/RewardButton.png";
import RuleButton from "../../assets/images/pk-events/RuleButton.png";

import fallbackImage1 from "../../assets/icons/selected_male.png";

import PodiumBackdrop from "../../assets/images/pk-events/11 (4).png";
import rank1Crest from "../../assets/images/pk-events/pktp1 1.png";
import rank2Crest from "../../assets/images/pk-events/11 (2).png";
import rank3Crest from "../../assets/images/pk-events/11 (3).png";
import RowBackground from "../../assets/images/pk-events/11 (5).png";
import RowAvatarRing from "../../assets/images/pk-events/11 (1).png";
import RowRankBadge from "../../assets/images/pk-events/11 (6).png";
import { useTranslation } from "react-i18next";
import TimerComponent from "./TimerComponent";
import { Link } from "react-router-dom";
import RewardDialog from "./RewardDialog";

// Avatar hole (% of each crest image, measured from its transparent circle)
const CREST_HOLES = {
  1: { crest: rank1Crest, size: 25.8, cx: 49.4, cy: 27.2 },
  2: { crest: rank2Crest, size: 44, cx: 49.8, cy: 27.1 },
  3: { crest: rank3Crest, size: 44, cx: 49.8, cy: 27.1 },
};

const Design = ({ weeklyData1, weeklyData2, weeklyData3, tops, bonusData }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("tab1");
  const [activeSubTabs, setActiveSubTabs] = useState({
    tab1: "tab11", // PK King - Previous Week
    tab2: "tab21", // PK Room - Previous Week
    tab3: "tab31", // PK Star - Previous Week
  });

  const openDialog = () => setIsDialogOpen(true);
  const closeDialog = () => setIsDialogOpen(false);
  const urlParams = new URLSearchParams(window.location.search);
  const imageBaseUrl = "https://media.smolivechat.com/";
  const [imageErrors, setImageErrors] = useState({});
  const [isRewardOpen, setIsRewardOpen] = useState(false);

  // Handle image error by updating the imageErrors state
  const handleError = (itemId) => {
    setImageErrors((prevState) => ({
      ...prevState,
      [itemId]: true,
    }));
  };

  const { t } = useTranslation();

  // Handle main tab change
  const handleMainTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  // Handle sub tab change
  const handleSubTabChange = (tabId) => {
    setActiveSubTabs((prev) => ({
      ...prev,
      [activeTab]: tabId,
    }));
  };

  // Get current active sub tab
  const getActiveSubTab = () => activeSubTabs[activeTab];

  // Previous-week winners have no "name" field (just an id), current-week ones do
  const normalizeWinner = (item, idField, imageField) => {
    if (!item) return null;
    return {
      id: item[idField],
      name: item.name || `#${item[idField]}`,
      image: item[imageField],
      score: item.totalGiftNum,
      uuid: item.uuid,
    };
  };

  // Get the top-3 winners for the active tab/sub-tab, plus any remaining ranked list
  const getCurrentData = () => {
    const subTab = getActiveSubTab();
    const isPreviousWeek = subTab === `${activeTab}1`;

    if (isPreviousWeek) {
      const prev = tops?.winner_previous_event || {};
      const config = {
        tab1: {
          list: prev.PK_king,
          idField: "sender_id",
          imageField: "avatar",
        },
        tab2: {
          list: prev.Room_pk,
          idField: "roomowner_id",
          imageField: "room_cover",
        },
        tab3: {
          list: prev.start_pk,
          idField: "reciver_id",
          imageField: "avatar",
        },
      }[activeTab];

      const winners = (config?.list || []).map((item) =>
        normalizeWinner(item, config.idField, config.imageField),
      );
      return { top3: winners.slice(0, 3), rest: winners.slice(3) };
    }

    const currentWeekData = {
      tab1: weeklyData1,
      tab2: weeklyData2,
      tab3: weeklyData3,
    }[activeTab];
    const winners = (currentWeekData?.top || []).map((item) =>
      normalizeWinner(item, "user_id", "avatar"),
    );
    return { top3: winners.slice(0, 3), rest: winners.slice(3) };
  };

  // Abbreviate large scores like the design mock (e.g. 38620000 -> "38.62M")
  const formatScore = (value) => {
    const num = Number(value) || 0;
    if (num >= 1_000_000) return `${(num / 1_000_000).toFixed(2)}M`;
    if (num >= 1_000) return `${(num / 1_000).toFixed(2)}K`;
    return `${num}`;
  };

  // Ranked row (rank 4 and below)
  const WinnerRow = ({ item, rank }) => (
    <div className="relative w-full" style={{ aspectRatio: "423 / 114" }}>
      <img
        src={RowBackground}
        alt=""
        className="absolute inset-0 h-full w-full object-fill"
      />
      <div
        className="absolute left-[5%] top-1/2 flex -translate-y-1/2 items-center justify-center"
        style={{ width: "9%", aspectRatio: "35 / 27" }}
      >
        <img
          src={RowRankBadge}
          alt=""
          className="absolute inset-0 h-full w-full object-fill"
        />
        <p className="absolute inset-0 flex items-center justify-center font-cairo font-semibold text-[16px] leading-[19px] gradientTextTimer">
          {rank}
        </p>
      </div>
      <div
        className="absolute left-[18%] top-[55%] -translate-y-1/2"
        style={{ width: "17%" }}
      >
        <div className="relative w-full">
          <img
            src={
              imageErrors[item?.image]
                ? fallbackImage1
                : `${imageBaseUrl}${item?.image}`
            }
            onError={() => handleError(item?.image)}
            alt={item?.name}
            className="absolute left-1/2 top-1/2 w-[82%] -translate-x-1/2 -translate-y-1/2 rounded-full object-cover"
            style={{ aspectRatio: "1 / 1" }}
          />
          <img
            src={RowAvatarRing}
            alt=""
            className="relative block h-auto w-full"
          />
        </div>
      </div>
      <p className="absolute left-[38%] top-1/2 w-[32%] -translate-y-1/2 flex items-center justify-start truncate font-cairo font-medium text-[20px] leading-[23px] gradientTextTimer">
        {item?.name}
      </p>
      <p className="absolute right-[5%] top-1/2 flex -translate-y-1/2 items-center justify-center font-cairo font-medium text-[20px] leading-[23px] gradientTextTimer">
        {formatScore(item?.score)}
      </p>
    </div>
  );

  // Winner crest for the top-3 podium (previous-week winners have no name, so "#id" is shown instead)
  const PodiumWinner = ({ winner, rank, className }) => {
    const hole = CREST_HOLES[rank];
    if (!winner) return null;

    return (
      <div className={className}>
        <img
          src={
            imageErrors[winner.image]
              ? fallbackImage1
              : `${imageBaseUrl}${winner.image}`
          }
          onError={() => handleError(winner.image)}
          alt={winner.name}
          className="absolute -translate-x-1/2 -translate-y-1/2 rounded-full object-cover"
          style={{
            left: `${hole.cx}%`,
            top: `${hole.cy}%`,
            width: `${hole.size}%`,
            aspectRatio: "1 / 1",
          }}
        />
        <img
          src={hole.crest}
          alt=""
          className="relative z-10 block w-full h-auto"
        />
        <div
          className="absolute left-1/2 z-20 flex w-[80%] -translate-x-1/2 flex-col items-center gap-0.5"
          style={{ top: "57%" }}
        >
          <p className="w-full truncate flex items-center justify-center font-cairo font-medium text-[18px] leading-[23px] gradientTextTimer [text-shadow:0px_0px_4px_rgba(0,0,0,0.25)]">
            {winner.name}
          </p>
          <p className="flex items-center justify-center font-cairo font-medium text-[16px] leading-[23px] gradientTextTimer [text-shadow:0px_0px_4px_rgba(0,0,0,0.25)]">
            {parseInt(winner.score) || 0}
          </p>
        </div>
      </div>
    );
  };

  // TOP1 / TOP2 / TOP3 podium
  const Podium = ({ top3 }) => {
    if (!top3?.length) return null;

    return (
      <div
        className="relative mx-auto w-full max-w-[320px]"
        style={{ aspectRatio: "423 / 660" }}
      >
        <img
          src={PodiumBackdrop}
          alt=""
          className="pointer-events-none absolute inset-0 h-full w-full rounded-xl object-cover"
        />
        <PodiumWinner
          winner={top3[0]}
          rank={1}
          className="absolute left-1/2 top-[3%] w-[62%] -translate-x-1/2"
        />
        <PodiumWinner
          winner={top3[1]}
          rank={2}
          className="absolute left-[4%] top-[46%] w-[46%]"
        />
        <PodiumWinner
          winner={top3[2]}
          rank={3}
          className="absolute right-[4%] top-[46%] w-[46%]"
        />
      </div>
    );
  };

  // Render sub tabs for current main tab
  const renderSubTabs = () => {
    const subTabsConfig = {
      tab1: [
        { id: "tab11", label: "Previous Week" }, // Previous Week
        { id: "tab12", label: "Current Week" }, // Current Week
      ],
      tab2: [
        { id: "tab21", label: "Previous Week" }, // Previous Week
        { id: "tab22", label: "Current Week" }, // Current Week
      ],
      tab3: [
        { id: "tab31", label: "Previous Week" }, // Previous Week
        { id: "tab32", label: "Current Week" }, // Current Week
      ],
    };

    const tabs = subTabsConfig[activeTab] || [];

    return (
        <div className="flex justify-center bg-[#0000004b] rounded-full w-fit my-10">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => handleSubTabChange(tab.id)}
            className={`px-6 py-3 rounded-full border-2 transition-all duration-300 ${
              getActiveSubTab() === tab.id
                ? "bg-gradient-to-br from-[#6B3FA0] via-[#3D2260] to-[#0A0505] border-[#FFD966]"
                : "border-transparent"
            }`}
          >
            <p
              className={`text-[18px] leading-none tracking-normal text-center ${
                getActiveSubTab() === tab.id
                  ? "font-semibold text-[#FFFBFF]"
                  : "font-medium text-[#FFFBFF99]"
              }`}
            >
              {t(tab.label)}
            </p>
          </button>
        ))}
      </div>
    );
  };

  // Render content based on current tabs
  const renderContent = () => {
    const { top3, rest } = getCurrentData();
    console.log(getCurrentData());
    if (top3.length === 0) {
      return <div className="text-white text-center py-10"></div>;
    }

    return (
      <div className="mx-auto mt-[10px] w-[90%] flex flex-col relative gap-6">
        <Podium top3={top3} />
        {rest.length > 0 && (
          <div className="flex flex-col gap-2 relative">
            {rest.map((item, index) => (
              <WinnerRow key={item?.id ?? index} item={item} rank={index + 4} />
            ))}
          </div>
        )}
      </div>
    );
  };

  // Main tab content renderer
  const renderTabContent = () => {
    return (
      <div className="tab-panel relative flex flex-col justify-center gap-5 items-center text-center">
        {renderSubTabs()}
        {renderContent()}
      </div>
    );
  };

  return (
    <div className="mainBg bg-[#0A0505] relative overflow-hidden">
      <div className="PK relative">
        <Dialog
          isOpen={isDialogOpen}
          closeDialog={closeDialog}
          description={tops?.pk_event?.description}
        />
        <RewardDialog
          isOpen={isRewardOpen}
          onClose={() => setIsRewardOpen(false)}
          rewardData={bonusData}
        />
        ;
        <div className="absolute top-[25%] z-[9999] right-0">
          <div
            onClick={openDialog}
            className="relative   inline-block cursor-pointer  "
          >
            <img src={RuleButton} alt="reward" className="w-[60px] h-[44px]" />
          </div>
        </div>
        <div className="absolute top-[36%] z-[999] right-0">
          <div
            onClick={() => setIsRewardOpen(true)}
            className="relative -right-2 inline-block cursor-pointer "
          >
            <img
              src={RewardButton}
              alt="reward"
              className="w-[100px] h-[44px]"
            />
          </div>
        </div>
      </div>

      <div className="relative !mt-[-15px] ">
        {tops?.pk_event?.remainingTime && (
          <TimerComponent initialTime={tops.pk_event.remainingTime} />
        )}
      </div>

      <div className="relative mt-[20px] w-full mx-auto">
        <div className="flex relative w-full mx-auto gap-2 justify-center">
          {[
            {
              id: "tab1",
              label: "PK King",
              imgActive: activeTabBar,
              imgInactive: tabBar,
            },
            {
              id: "tab2",
              label: "PK Room",
              imgActive: activeTabBar,
              imgInactive: tabBar,
            },
            {
              id: "tab3",
              label: "PK Star",
              imgActive: activeTabBar,
              imgInactive: tabBar,
            },
          ].map((tab) => (
            <div
              key={tab.id}
              className="relative w-[32%] flex flex-row cursor-pointer"
              onClick={() => handleMainTabChange(tab.id)}
            >
              <img
                src={activeTab === tab.id ? tab.imgActive : tab.imgInactive}
                alt={tab.label}
                className="h-[48px]"
              />
              <p
                className={`absolute w-full py-3  top-1/2 left-[50%] transform -translate-x-1/2 sm:-translate-y-1/2 xs:-translate-y-[50%] text-[18px] leading-none tracking-normal text-center ${
                  activeTab === tab.id
                    ? "font-semibold gradientTextRules"
                    : "font-medium gradientTextMuted"
                }`}
              >
                {t(tab.label)}
              </p>
            </div>
          ))}
        </div>

        {renderTabContent()}
      </div>
    </div>
  );
};

export default Design;
